import { Component, HostBinding, Input } from "@angular/core";

@Component({
    selector: 'app-versatile-list-header',
    template: `
        <ng-content></ng-content>`,
    styleUrls: ['./versatile-list-header.component.scss']
})
export class VersatileListHeaderComponent {
    @HostBinding('class.header') hostClass = true;
    @Input() isLoading = false;

    @HostBinding('class.loading')
    get loadingClass(): boolean {
        return this.isLoading;
    }
}
